module.exports = __webpack_public_path__ + "ab2b7bd79ffacbc3fc204ea6623152ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-10.png
// module id = 3203
// module chunks = 0